import { Map } from 'immutable';
import { myRemoveEntities, myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT } from '../../sagas/actions';
import * as MatchResultsAction from '../../actions/matchResults';
import * as LiveActions from '../../actions/live';
export default function scoresReducer(scores, action) {
    switch (action.type) { //eslint-disable-line default-case
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
        case MatchResultsAction.FETCH_MATCH_RESULTS:
        case MatchResultsAction.CLEAR_MATCH_RESULTS:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case MatchResultsAction.SUCCESS_FETCH_MATCH_RESULTS:
            return init(Map(), action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
            return update(scores, action.data);
    }
    return scores;
}
function init(scores, data) {
    if (data.scores !== undefined) {
        scores = addScores(scores, data.scores.add);
    }
    return scores;
}
function update(scores, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        scores = myRemoveEntitiesBySport(scores, 'sportId', data.sports.remove);
    }
    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        scores = myRemoveEntities(scores, 'leagueId', data.leagues.remove);
    }
    if (data.events != undefined && data.events.remove !== undefined) {
        scores = myRemoveEntities(scores, 'matchId', data.events.remove);
    }
    if (data.scores !== undefined) {
        scores = myRemoveEntities(scores, 'id', data.scores.remove);
        scores = addScores(scores, data.scores.add);
        scores = changeScores(scores, data.scores.change);
    }
    return scores;
}
function addScores(scores, addScores) {
    if (addScores === undefined) {
        return scores;
    }
    return scores.withMutations(function (s) {
        for (var i = 0; i < addScores.length; i++) {
            var score = Map(addScores[i]);
            s.set(score.get('id'), score);
        }
    });
}
function changeScores(scores, changeScores) {
    if (changeScores === undefined) {
        return scores;
    }
    return scores.withMutations(function (s) {
        for (var i = 0; i < changeScores.length; i++) {
            var score = new Map(changeScores[i]);
            s.set(score.get('id'), score);
        }
    });
}



// WEBPACK FOOTER //
// ./src/reducers/entities/scoresReducer.js